import styled from 'styled-components';
import { ImageComponent } from '@/components/Image';
import { fpx } from '../../../../styles/fluid';

const CARD_BG = '#171717';

export const ScVipBonuses = styled.section`
  position: absolute;
  z-index: 2;
  top: calc(${fpx(165)} + var(--hero-shift));
  left: ${fpx(537)};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${fpx(16)};
  width: ${fpx(656)};

  @media (orientation: portrait) {
    position: static;
    width: ${fpx(344)};
    margin-top: ${fpx(32)};
    align-items: flex-start;
  }
`;

// Each layer is blurred on its own and they stack; blurring one shared parent would look like a single layer.
export const ScHeadingShadow = styled.span`
  position: absolute;
  z-index: -1;
  top: ${fpx(-4)};
  left: ${fpx(174)};
  width: ${fpx(308)};
  height: ${fpx(36)};
  border-radius: 999px;
  background: #000;
  filter: blur(${fpx(25)});
  pointer-events: none;

  @media (orientation: portrait) {
    display: none;
  }
`;

export const ScVipHeading = styled.h2`
  margin: 0;
  width: 100%;
  color: #fff;
  font-size: ${fpx(22)};
  font-weight: 700;
  line-height: ${fpx(28)};
  letter-spacing: 0.44px;
  text-align: center;
  text-transform: uppercase;

  @media (orientation: portrait) {
    font-size: ${fpx(18)};
    line-height: ${fpx(26)};
    letter-spacing: 0.4px;
    text-align: left;
  }
`;

export const ScVipList = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${fpx(16)};

  @media (orientation: portrait) {
    flex-direction: column;
    gap: ${fpx(12)};
    width: 100%;
  }
`;

export const ScVipCard = styled.div<{ $color: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: ${fpx(208)};
  height: ${fpx(210)};
  padding: ${fpx(16)};
  border: 1px solid ${({ $color }) => $color};
  border-radius: ${fpx(24)};
  background: ${CARD_BG};
  overflow: hidden;

  @media (orientation: portrait) {
    flex-direction: row;
    width: 100%;
    height: ${fpx(104)};
    padding: ${fpx(12)} ${fpx(16)} ${fpx(12)} ${fpx(12)};
  }
`;

export const ScTierArtwork = styled(ImageComponent)`
  display: block;
  flex-shrink: 0;
  width: ${fpx(128)};
  height: ${fpx(101)};
  object-fit: contain;

  @media (orientation: portrait) {
    height: ${fpx(78)};
  }
`;

export const ScCashback = styled.div<{ $color: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  line-height: normal;

  .percent {
    color: ${({ $color }) => $color};
    font-size: ${fpx(40)};
    font-weight: 700;
    text-transform: uppercase;
  }

  .description {
    color: #fff;
    font-size: ${fpx(18)};
    font-weight: 500;
    white-space: nowrap;
  }

  &.lang-de .description,
  &.lang-fr-CA .description,
  &.lang-fr-CH .description {
    font-size: ${fpx(14)};
  }

  @media (orientation: portrait) {
    align-items: flex-end;
    width: ${fpx(186)};
    text-align: right;

    .percent {
      font-size: ${fpx(36)};
    }

    .description {
      font-size: ${fpx(16)};
    }

    &.lang-de .description,
    &.lang-fr-CA .description,
    &.lang-fr-CH .description {
      font-size: ${fpx(15)};
    }
  }
`;
